import { gql } from 'apollo-angular';

export var blocked_committee_dates = gql`
  query blockedCommitteeDates($start: Date!, $end: Date!) {
    blockedCommitteeDates(date: { to: $start, from: $end }) {
      id
      date
    }
    me {
      permissionsForResource(resourceType: BLOCKEDCOMMITTEEDATE) {
        _edit
      }
    }
  }
`;
